<ng-container *ngIf="weatherChannel">
    <div class="d-flex justify-content-between">
        <h6 class="fw-semibold text-secondary">Wettereinstellungen</h6>
        <div class="text-end ms-2">
            <p class="text-secondary small mb-0">Im Schema werden maximal {{ maxSchemaTypes }} Datentypen angezeigt,
                in der Detailansicht sind maximal {{ maxDetailTypes }} wählbar.</p>
            <span *ngIf="information" class="text-danger">{{ information }}</span>
        </div>
    </div>

    <div class="row text-secondary mt-3 pb-1 border-bottom border-danger">
        <div class="col-6">Datentyp</div>
        <div class="col-3 text-center">Schema</div>
        <div class="col-3 text-center">Detailansicht</div>
    </div>
    <div class="row align-items-center border-bottom" *ngFor="let row of rows">
        <div class="col-6 d-flex align-items-center py-1">
            <img class="me-2" height="20" [src]="row.iconPath" [alt]="'Icon ' + row.label">
            {{ row.label }}<span *ngIf="row.unit" class="text-secondary ms-1">[{{ row.unit }}]</span>
        </div>
        <div class="col-3 text-center">
            <mat-checkbox [checked]="isSchemaSelected(row.type)" [disabled]="!isConfigLoaded || isSchemaDisabled(row.type)"
                (change)="onSchemaChange(row.type, $event.checked)"
                matTooltip="Anzeige an der Station im Schema"></mat-checkbox>
        </div>
        <div class="col-3 text-center">
            <mat-checkbox [checked]="isDetailSelected(row.type)" [disabled]="!isConfigLoaded || isDetailDisabled(row.type)"
                (change)="onDetailChange(row.type, $event.checked)"
                matTooltip="Anzeige in der Detailansicht und im Verlauf"></mat-checkbox>
        </div>
    </div>
    <div class="text-end" *ngIf="isAnyValueChanged">
        <button class="btn btn-outline-danger rounded-0 mt-5 ms-2" type="button"
            (click)="onSaveBtnClicked()">Speichern</button>
    </div>
</ng-container>
<div *ngIf="!weatherChannel">
    <p class="text-secondary">Keine Wettereinstellungen verfügbar.</p>
</div>
